<div class="videowrapper">
  <div id="player"></div>
</div>